<template>
  <div>
    <v-dialog
      v-model="dialogOpen"
      content-class="my-custom-dialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      @keydown.esc="close"
    >
      <v-card class="template-settings-modal">
        <v-card-title class="template-settings-header">
          <h2 class="settings-title">Konfiguracija blagajne</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="close" class="close-settings-btn">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="template-settings-body">
          <v-container class="panel-container">
            <v-row class="pb-0 mb-0">
              <v-col class="pb-0 mb-0" cols="12">
                <v-select
                  v-model="selectedTemplate"
                  :items="computedAvailableTemplates"
                  item-text="label"
                  item-value="value"
                  item-disabled="disabled"
                  @change="onSelectTemplate"
                ></v-select>
              </v-col>
            </v-row>
            <v-row
              v-if="selectedTemplate === 'ai-crud' || selectedTemplate === 'ai-compact'"
              class="pb-0 mb-0 pt-0 mt-0"
            >
              <v-col class="pb-0 mb-0 pt-0 mt-0" cols="12">
                <v-select
                  label="Tip pretraživanja"
                  v-model="selectedSearchType"
                  :items="availableSearchTypes"
                  item-text="label"
                  item-value="value"
                  @change="onSelectSearchType"
                >
                </v-select>
                <div v-html="showExplanation()"></div>
              </v-col>
            </v-row>
            <v-row
              class="pt-0 mt-0"
              v-if="
                selectedTemplate === 'panel' ||
                selectedTemplate === 'ai-caffe-wide' ||
                selectedTemplate === 'bottom-up'
              "
            >
              <v-col class="pt-0 mt-0" cols="6">
                <p class="subsection-label">Template gumbi za plaćanje</p>
                <v-radio-group row v-model="selectedPaymentPanel" @change="selectPaymentPanel">
                  <v-radio
                    label="default"
                    value="default"
                  />
                  <v-radio
                    label="simple"
                    value="simple"
                  />
                </v-radio-group>
              </v-col>
              <v-col
                v-if="
                  selectedTemplate === 'ai-caffe-wide' ||
                  selectedTemplate === 'bottom-up'
                "
                class="pt-0 mt-0"
                cols="6"
              >
                <p class="subsection-label">Podešavanje template-a</p>
                <v-row style="margin-top: -1rem">
                  <v-col cols="4" class="slider-label">Redovi:</v-col>
                  <v-col cols="8">
                    <v-slider
                      min="1"
                      max="12"
                      v-model="panelRows"
                      thumb-label="always"
                      @change="adjustTemplate()"
                    ></v-slider>
                  </v-col>
                </v-row>
                <v-row style="margin-top: -2rem">
                  <v-col cols="4" class="slider-label">Stupci:</v-col>
                  <v-col cols="8">
                    <v-slider
                      min="1"
                      max="12"
                      thumb-label="always"
                      v-model="panelCols"
                      @change="adjustTemplate()"
                    ></v-slider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row
              class="pt-0 mt-0"
              v-if="selectedTemplate === 'ai-caffe-wide'"
            >
              <v-col
                v-if="selectedTemplate === 'ai-caffe-wide'"
                class="pt-0 mt-0"
                cols="12"
              >
                <p class="section-title">
                  Podešavanje izgleda košarice
                </p>
                <v-row style="margin-top: -1rem">
                  <table class="tableCart">
                    <tbody>
                      <tr>
                        <td>
                          <v-checkbox
                            class="d-inline-flex"
                            color="green"
                            dense
                            style="text-align: center !important"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.rb"
                          ></v-checkbox>
                        </td>
                        <td style="text-align: center">
                          <v-checkbox
                            class="d-inline-flex"
                            color="green"
                            dense
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.name"
                            :readonly="true"
                          ></v-checkbox>
                        </td>

                        <td style="text-align: center">
                          <v-checkbox
                            dense
                            class="d-inline-flex"
                            color="green"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.quantity"
                            :readonly="true"
                          ></v-checkbox>
                        </td>
                        <td style="text-align: center">
                          <v-checkbox
                            dense
                            class="d-inline-flex"
                            color="green"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.pending_quantity"
                          ></v-checkbox>
                        </td>
                        <td style="text-align: center">
                          <v-checkbox
                            dense
                            class="d-inline-flex"
                            color="green"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.unit"
                          ></v-checkbox>
                        </td>
                        <td style="text-align: center">
                          <v-checkbox
                            dense
                            class="d-inline-flex"
                            color="green"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.single_price"
                            :readonly="true"
                          ></v-checkbox>
                        </td>
                        <td style="text-align: center">
                          <v-checkbox
                            dense
                            class="d-inline-flex"
                            color="green"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.single_price_discount"
                          ></v-checkbox>
                        </td>
                        <td style="text-align: center">
                          <v-checkbox
                            dense
                            class="d-inline-flex"
                            color="green"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.total"
                            :readonly="true"
                          ></v-checkbox>
                        </td>
                        <td style="text-align: center">
                          <v-checkbox
                            dense
                            class="d-inline-flex"
                            color="green"
                            hide-details
                            @change="changeCartConfiguration()"
                            v-model="cartConfiguration.action_icons"
                          ></v-checkbox>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center">Rb.</td>
                        <td style="text-align: center">Naziv</td>
                        <td style="text-align: center">Količina</td>
                        <td style="text-align: center">Pending kol.</td>
                        <td style="text-align: center">Mj. jedinica</td>
                        <td style="text-align: center">Jed. cijena</td>
                        <td style="text-align: center">Jed. cijena s pop.</td>
                        <td style="text-align: center">Ukupno</td>
                        <td style="text-align: center">Akcije</td>
                      </tr>
                    </tbody>
                  </table>
                </v-row>
              </v-col>
            </v-row>

            <!-- Keyboard Shortcuts Settings -->
            <v-row
              class="pt-0 mt-0"
              v-if="
                selectedTemplate === 'ai-caffe-wide' ||
                selectedTemplate === 'bottom-up' ||
                selectedTemplate === 'panel'
              "
            >
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <div class="section-title-with-help">
                  <p class="section-title">Keyboard Shortcuts</p>
                  <v-btn
                    icon
                    small
                    @click="shortcutsHelpDialog = true"
                    class="help-icon-btn"
                  >
                    <v-icon small>mdi-help-circle</v-icon>
                  </v-btn>
                </div>
                <v-row>
                  <v-col cols="12">
                    <v-switch
                      v-model="keyboardShortcutsEnabled"
                      label="Omogući keyboard shortcuts na tipkovnici"
                      color="green"
                      hide-details
                      @change="saveKeyboardSettings"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row v-if="keyboardShortcutsEnabled">
                  <v-col cols="12">
                    <v-switch
                      v-model="showShortcutBadges"
                      label="Prikaži shortcuts na ekranu"
                      color="green"
                      hide-details
                      @change="saveKeyboardSettings"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Category Modal Settings -->
            <v-row class="pt-0 mt-0" v-if="selectedTemplate === 'ai-caffe-wide' || selectedTemplate === 'bottom-up' || selectedTemplate === 'panel'">
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <p class="section-title">Ponašanje prozora kategorija i tražilice</p>
                <v-row>
                  <v-col cols="12">
                    <v-switch v-model="closeModalOnProductClick" label="Zatvori prozor nakon klika na artikl" color="green" hide-details @change="saveModalCloseSetting"></v-switch>
                    <p class="text-caption mt-2 grey--text">Kada je ova opcija uključena, prozor s artiklima će se automatski zatvoriti nakon što kliknete na artikl.</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Category Display Mode Settings -->
            <v-row class="pt-0 mt-0" v-if="selectedTemplate === 'ai-caffe-wide' || selectedTemplate === 'bottom-up' || selectedTemplate === 'panel'">
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <p class="section-title">Prikaz artikala u kategorijama i tražilici</p>
                <v-radio-group v-model="categoryDisplayMode" @change="saveCategoryDisplayMode" hide-details>
                  <v-radio label="Pločice (Grid)" value="tiles" color="green"></v-radio>
                  <v-radio label="Redci (Lista)" value="rows" color="green"></v-radio>
                </v-radio-group>
                <p class="text-caption mt-2 grey--text">
                  Odaberite kako će se artikli prikazivati unutar kategorija i tražilice.
                  Pločice prikazuju artikle kao kartice, a Redci kao listu s detaljima.
                </p>
              </v-col>
            </v-row>

            <!-- Barcode Scanner Settings -->
            <v-row class="pt-0 mt-0" v-if="selectedTemplate === 'ai-caffe-wide' || selectedTemplate === 'bottom-up' || selectedTemplate === 'panel'">
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <p class="section-title">Barkod čitač</p>
                <v-row>
                  <v-col cols="12">
                    <v-switch v-model="useBarcodeScanner" label="Koristi barkod čitač" color="green" hide-details @change="saveBarcodeSetting"></v-switch>
                    <p class="text-caption mt-2 grey--text">Kada je ova opcija uključena, možete koristiti barkod čitač za dodavanje artikala u račun.</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Quantity Bar Settings -->
            <v-row class="pt-0 mt-0" v-if="selectedTemplate === 'ai-caffe-wide' || selectedTemplate === 'bottom-up' || selectedTemplate === 'panel'">
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <p class="section-title">Quantity Bar (Brzi odabir količine)</p>
                <v-row>
                  <v-col cols="12">
                    <v-switch
                      v-model="quantityBarEnabled"
                      label="Prikaži traku za brzi odabir količine"
                      color="green"
                      hide-details
                      @change="saveQuantityBarSetting"
                    ></v-switch>
                    <p class="text-caption mt-2 grey--text">
                      Kada je ova opcija uključena, prikazuje se traka s brzim gumbima za odabir količine (×1, ×2, ×3, ×5, ×10)
                      iznad proizvoda. Omogućava dodavanje proizvoda s prilagođenom količinom jednim klikom.
                    </p>
                  </v-col>
                </v-row>
                <v-row v-if="quantityBarEnabled" class="mt-2">
                  <v-col cols="12">
                    <v-switch
                      v-model="quantityBarAutoReset"
                      label="Automatski reset količine nakon dodavanja proizvoda"
                      color="green"
                      hide-details
                      @change="saveQuantityBarSetting"
                    ></v-switch>
                    <p class="text-caption mt-2 grey--text">
                      Automatski vraća odabranu količinu na ×1 nakon svakog dodavanja proizvoda.
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Payment Methods Configuration -->
            <v-row v-if="selectedTemplate !== 'ai-shop'" class="pt-0 mt-0">
              <v-col cols="12">
                <v-divider class="mb-3"></v-divider>
                <p class="section-title mb-2">Dostupni načini plaćanja</p>
                <v-row class="mt-0">
                  <v-col cols="12" class="py-1">
                    <v-checkbox
                      v-model="enabledPaymentMethods.paymentSelection"
                      label="Odabir plaćanja"
                      color="primary"
                      hide-details
                      dense
                      @change="onPaymentSelectionChange"
                    ></v-checkbox>
                    <p class="text-caption mt-1 mb-0 grey--text">
                      Prikazuje gumb koji otvara modal za odabir načina plaćanja (poništava ostale opcije)
                    </p>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="12" class="py-1">
                    <v-checkbox
                      v-model="enabledPaymentMethods.cash"
                      label="Gotovinski"
                      color="green"
                      hide-details
                      dense
                      :disabled="enabledPaymentMethods.paymentSelection"
                      @change="savePaymentMethodsConfig"
                    ></v-checkbox>
                    <p class="text-caption mt-1 mb-0 grey--text">
                      Prikazuje gumb za plaćanje gotovinom
                    </p>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="12" class="py-1">
                    <v-checkbox
                      v-model="enabledPaymentMethods.card"
                      label="Kartično"
                      color="green"
                      hide-details
                      dense
                      :disabled="enabledPaymentMethods.paymentSelection"
                      @change="savePaymentMethodsConfig"
                    ></v-checkbox>
                    <p class="text-caption mt-1 mb-0 grey--text">
                      Prikazuje gumb za plaćanje karticom
                    </p>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="12" class="py-1">
                    <v-checkbox
                      v-model="enabledPaymentMethods.r1"
                      label="R1"
                      color="green"
                      hide-details
                      dense
                      :disabled="enabledPaymentMethods.paymentSelection"
                      @change="savePaymentMethodsConfig"
                    ></v-checkbox>
                    <p class="text-caption mt-1 mb-0 grey--text">
                      Prikazuje gumb za R1 račune
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Table Settings (only for Caffe restaurant) -->
            <v-row
              class="pt-0 mt-0"
              v-if="selectedTemplate === 'ai-caffe-wide'"
            >
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <p class="section-title">
                  Stolovi
                </p>
                <v-row>
                  <v-col cols="12">
                    <v-switch
                      v-model="useTables"
                      label="Koristiti stolove"
                      color="green"
                      hide-details
                      @change="saveTableSettings"
                    ></v-switch>
                    <p class="text-caption mt-2 grey--text">
                      Omogućite ovu opciju za korištenje stolova u blagajni.
                    </p>
                  </v-col>
                </v-row>

                <!-- Table Mode Selection (only when useTables is enabled) -->
                <v-row v-if="useTables" class="mt-3">
                  <v-col cols="12">
                    <v-radio-group
                      v-model="tableMode"
                      hide-details
                      @change="saveTableSettings"
                    >
                      <v-radio
                        label="Popis stolova"
                        value="list"
                        color="green"
                      ></v-radio>
                      <p class="text-caption ml-8 grey--text" style="margin-top: -8px; margin-bottom: 12px;">
                        Prikazuje standardne gumbe za odabir stolova
                      </p>

                      <v-radio
                        label="Tlocrt stolova"
                        value="floor"
                        color="green"
                      ></v-radio>
                      <p class="text-caption ml-8 grey--text" style="margin-top: -8px;">
                        Prikazuje gumb za otvaranje tlocrta restorana
                      </p>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Shortcuts Help Dialog -->
    <v-dialog v-model="shortcutsHelpDialog" max-width="800px">
      <v-card class="shortcuts-help-modal">
        <v-card-title class="shortcuts-help-header">
          <h2 class="modal-title">Upute za korištenje keyboard shortcuts</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="shortcutsHelpDialog = false" class="close-btn-help">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="shortcuts-help-body pt-6 pb-6">
          <div class="shortcuts-help-content">
            <!-- Pravila za generiranje shortcuts-a -->
            <h3 class="section-heading mb-3">📋 Kako se kreiraju shortcuts</h3>
            <ul class="mb-4">
              <li>
                <strong>Kategorije:</strong> Dobivaju brojeve 1-9 prema
                redoslijedu
              </li>
              <li>
                <strong>Proizvodi:</strong> Prvih slova prvih 2 riječi naziva
                (npr. "Coca Cola" → CC)
              </li>
              <li>
                <strong>Sobe (Room tabs):</strong> Prvo slovo naziva sobe (npr.
                "Terasa" → T, "Restoran" → R)
                <ul class="mt-1">
                  <li>
                    Ako ima više soba s istim slovom → dodaje se broj (T, T1,
                    T2...)
                  </li>
                  <li>Koristi se za prebacivanje između tab-ova na tlocrtu</li>
                </ul>
              </li>
              <li>
                <strong>Prostorije (Areas):</strong> Prvo slovo naziva
                prostorije (npr. "Terasa" → T, "Bar" → B)
                <ul class="mt-1">
                  <li>Prostorije su pravokutne zone na tlocrtu</li>
                  <li>
                    Ako ima više prostorija s istim slovom → dodaje se broj (T,
                    T1, T2...)
                  </li>
                </ul>
              </li>
              <li>
                <strong>Stolovi i Barovi:</strong> Brojevi iz naziva (prva 3
                broja):
                <ul class="mt-1">
                  <li>"Stol 1" → 1</li>
                  <li>"Stol 21" → 21</li>
                  <li>"Stol 311" → 311</li>
                  <li>
                    Ako nema broja u nazivu → dobiva broj od 100 nadalje (100,
                    101, 102...)
                  </li>
                  <li>
                    Ako je broj dupliciran → dodaje se prefix
                    <strong>X</strong> (npr. X1, X21)
                  </li>
                  <li>
                    <strong>Tipkovnica:</strong> Utipkajte samo broj stola (npr.
                    1, 21, 100)
                  </li>
                  <li>
                    <strong>Prikaz na blagajni:</strong> Slovo prostorije + broj
                    stola (npr. T1, T21, B100)
                  </li>
                </ul>
              </li>
            </ul>

            <!-- Iznimke -->
            <h3 class="section-heading mb-3">⚠️ Iznimke i pravila</h3>
            <ul class="mb-4">
              <li>
                <strong>Normalizacija znakova:</strong> Hrvatska slova se prvo
                pretvaraju u engleska
                <ul class="mt-1">
                  <li>š, Š → s, S</li>
                  <li>č, Č → c, C</li>
                  <li>ć, Ć → c, C</li>
                  <li>ž, Ž → z, Z</li>
                  <li>đ, Đ → d, D</li>
                  <li>
                    Primjer: "Štruca kruha" → shortcut je <strong>SK</strong>
                  </li>
                  <li>
                    Primjer: "Češko pivo" → shortcut je <strong>CP</strong>
                  </li>
                </ul>
              </li>
              <li>
                Ako shortcut počinje s <strong>brojem</strong> → automatski se
                dodaje prefix <strong>X</strong>
              </li>
              <li>
                <strong>SVA rezervirana slova zamijenjuju se sa 'X'</strong> u
                cijelom shortcutu (bilo gdje da se pojave)
              </li>
              <li>
                <strong>Primjer:</strong> proizvod "5 minuta" → shortcut je
                <strong>X5M</strong> (počinje s brojem)
              </li>
              <li>
                <strong>Primjer:</strong> proizvod "Sok" → shortcut je
                <strong>X</strong> (S se zamijeni sa X)
              </li>
              <li>
                <strong>Primjer:</strong> proizvod "Kava" → shortcut je
                <strong>XA</strong> (K se zamijeni sa X)
              </li>
              <li>
                <strong>Primjer:</strong> proizvod "Special Offer" → shortcut
                je <strong>XX</strong> (S→X, O→X)
              </li>
              <li>
                <strong>Primjer:</strong> proizvod "Fresh Tea" → shortcut je
                <strong>XX</strong> (F→X, T→X)
              </li>
            </ul>

            <!-- Rezervirana slova -->
            <h3 class="section-heading mb-3">🔒 Rezervirana slova (za gumbe)</h3>
            <v-simple-table dense class="shortcuts-table mb-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="table-header">Slovo</th>
                    <th class="table-header">Gumb</th>
                    <th class="table-header">Opis</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><v-chip small color="primary" dark>F</v-chip></td>
                    <td>Pretraga</td>
                    <td>Otvara dialog za pretragu artikala</td>
                  </tr>
                  <tr>
                    <td><v-chip small color="primary" dark>T</v-chip></td>
                    <td>Stolovi</td>
                    <td>
                      Otvara tlocrt stolova ili popis stolova (ovisno o
                      postavci)
                    </td>
                  </tr>
                  <tr>
                    <td><v-chip small color="primary" dark>S</v-chip></td>
                    <td>Spremi</td>
                    <td>Sprema narudžbu na stol</td>
                  </tr>
                  <tr>
                    <td><v-chip small color="primary" dark>O</v-chip></td>
                    <td>Očisti</td>
                    <td>Briše narudžbu sa stola</td>
                  </tr>
                  <tr>
                    <td><v-chip small color="primary" dark>G</v-chip></td>
                    <td>Gotovina</td>
                    <td>Plaćanje gotovinom</td>
                  </tr>
                  <tr>
                    <td><v-chip small color="primary" dark>K</v-chip></td>
                    <td>Kartično</td>
                    <td>Plaćanje karticom</td>
                  </tr>
                  <tr>
                    <td><v-chip small color="success" dark>Enter</v-chip></td>
                    <td>Plaćanje</td>
                    <td>Otvara modal za odabir načina plaćanja (Gotovina/Kartično/R1)</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- Dugo držanje Space tipke -->
            <h3 class="section-heading mb-3">⏱️ Privremeni prikaz shortcuts-a</h3>
            <ul class="mb-4">
              <li>
                Pritisnite i držite tipku
                <strong>Space (razmaknica)</strong> duže od 600ms (0.6 sekundi)
              </li>
              <li>
                Privremeno će se prikazati
                <strong>svi shortcut badgevi</strong> na ekranu
              </li>
              <li>
                Badge-vi će ostati vidljivi dok god držite tipku
                <strong>Space (razmaknica)</strong>
              </li>
              <li>
                Kada pustite tipku, badge-vi se skrivaju (osim ako je opcija
                "Prikaži shortcuts na ekranu" uključena)
              </li>
              <li>
                Korisno za pregled svih dostupnih shortcuts-a bez uključivanja
                stalne prikazivanja
              </li>
              <li>
                <strong>Zašto Space?</strong> Tipka Space se koristi jer slovo
                'S' je rezervirano za funkciju "Spremi"
              </li>
            </ul>

            <!-- Dodatne napomene -->
            <h3 class="section-heading mb-3">💡 Dodatne napomene</h3>
            <ul>
              <li>
                Shortcuts su jedinstveni po tipu (proizvodi, stolovi,
                prostorije)
              </li>
              <li>Shortcuts ne rade dok tipkate u input polju</li>
              <li>
                Shortcuts za gumbe ne rade ako je gumb onemogućen (disabled)
              </li>
              <li>
                Za višeslovna imena proizvoda možete upisati više slova
                uzastopno
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions class="shortcuts-help-actions">
          <v-spacer></v-spacer>
          <v-btn @click="shortcutsHelpDialog = false" class="close-action-btn">
            Zatvori
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import state from '@/state'
import { df } from '@/plugins/firebase'
import EventBus from '@/plugins/event-bus'

export default {
  data () {
    return {
      dialogOpen: true,
      selectedTemplate: {},
      selectedPaymentPanel: undefined,
      panelCols: null,
      panelRows: null,
      panelColspan: null,
      availableTemplates: [
        { label: 'Aikasa', value: 'ai-crud' },
        { label: 'Aikasa Compact', value: 'ai-compact' },
        { label: 'Caffe restaurant', value: 'ai-caffe-wide' },
        { label: 'Aikasa Smart POS', value: 'ai-shop' }

        // { label: 'components-bottom-up', value: 'bottom-up' },
      ],
      cartConfiguration: {
        rb: true,
        name: true,
        quantity: true,
        pending_quantity: false,
        unit: true,
        single_price: true,
        single_price_discount: true,
        total: true
      },
      availableSearchTypes: [
        { label: 'Učitani artikli', value: 'load' },
        { label: 'Pretraži na upis', value: 'query' }
      ],
      selectedSearchType: undefined,
      keyboardShortcutsEnabled: false,
      showShortcutBadges: false,
      closeModalOnProductClick: false,
      categoryDisplayMode: 'tiles', // 'tiles' or 'rows'
      useBarcodeScanner: false,
      quantityBarEnabled: false, // Quantity Bar - defaultno isključeno
      quantityBarAutoReset: true, // Auto-reset količine nakon dodavanja
      useFloorPlan: false, // deprecated - keep for migration
      useTables: true, // Master switch - defaultno uključen
      tableMode: 'list', // 'list' ili 'floor'
      shortcutsHelpDialog: false,
      enabledPaymentMethods: { cash: true, card: true, r1: true, paymentSelection: false }
    }
  },
  computed: {
    computedAvailableTemplates () {
      const cashRegister = state.getCashRegister()
      const isWholesale = cashRegister && cashRegister.type === 'VP'

      return this.availableTemplates.map(template => {
        if (template.value === 'ai-caffe-wide' && isWholesale) {
          return {
            ...template,
            label: `${template.label} (samo za maloprodajnu blagajnu)`,
            disabled: true
          }
        }
        return { ...template, disabled: false }
      })
    }
  },
  methods: {
    getLocalStorageKey () {
      return `keyboard_shortcuts_${state.getCashRegister().id}`
    },
    getBarcodeStorageKey () {
      return `use_barcode_scanner_${state.getCashRegister().id}`
    },
    getFloorPlanStorageKey () {
      return `use_floor_plan_${state.getCashRegister().id}`
    },
    getTableSettingsStorageKey () {
      return `use_tables_${state.getCashRegister().id}`
    },
    getTableModeStorageKey () {
      return `table_mode_${state.getCashRegister().id}`
    },
    getTableSettingsInitializedKey () {
      return `table_settings_initialized_${state.getCashRegister().id}`
    },
    getModalCloseStorageKey () {
      return `close_modal_on_product_click_${state.getCashRegister().id}`
    },
    getCategoryDisplayModeStorageKey () {
      return `category_display_mode_${state.getCashRegister().id}`
    },
    loadBarcodeSetting () {
      try {
        const key = this.getBarcodeStorageKey()
        const saved = localStorage.getItem(key)
        if (saved !== null) {
          this.useBarcodeScanner = saved === 'true'
        }
      } catch (err) {
        console.error('Error loading barcode scanner setting:', err)
      }
    },
    saveBarcodeSetting () {
      try {
        const key = this.getBarcodeStorageKey()
        localStorage.setItem(key, this.useBarcodeScanner.toString())

        // Emit event to update PanelRowsWide
        EventBus.$emit('barcode-scanner-changed', this.useBarcodeScanner)
      } catch (err) {
        console.error('Error saving barcode scanner setting:', err)
      }
    },

    getQuantityBarStorageKey () {
      return `quantity_bar_enabled_${state.getCashRegister().id}`
    },

    getQuantityBarAutoResetStorageKey () {
      return `quantity_bar_auto_reset_${state.getCashRegister().id}`
    },

    loadQuantityBarSetting () {
      try {
        const enabledKey = this.getQuantityBarStorageKey()
        const autoResetKey = this.getQuantityBarAutoResetStorageKey()

        const savedEnabled = localStorage.getItem(enabledKey)
        const savedAutoReset = localStorage.getItem(autoResetKey)

        if (savedEnabled !== null) {
          this.quantityBarEnabled = savedEnabled === 'true'
        }
        if (savedAutoReset !== null) {
          this.quantityBarAutoReset = savedAutoReset === 'true'
        } else {
          this.quantityBarAutoReset = true // Default
        }
      } catch (err) {
        console.error('Error loading quantity bar setting:', err)
      }
    },

    saveQuantityBarSetting () {
      try {
        const enabledKey = this.getQuantityBarStorageKey()
        const autoResetKey = this.getQuantityBarAutoResetStorageKey()

        localStorage.setItem(enabledKey, this.quantityBarEnabled.toString())
        localStorage.setItem(autoResetKey, this.quantityBarAutoReset.toString())

        // Emit event to update PanelRowsWide
        EventBus.$emit('quantity-bar-setting-changed', {
          enabled: this.quantityBarEnabled,
          autoReset: this.quantityBarAutoReset
        })
      } catch (err) {
        console.error('Error saving quantity bar setting:', err)
      }
    },
    async loadPaymentMethodsConfig () {
      try {
        const cashReg = state.getCashRegister()
        const doc = await df.doc(`cash_registers/${cashReg.id}`).get()
        const data = doc.data()

        if (data && data.enabled_payment_methods) {
          this.enabledPaymentMethods = data.enabled_payment_methods
          state.setEnabledPaymentMethods(data.enabled_payment_methods)
        }
      } catch (err) {
        console.error('Error loading payment methods config:', err)
      }
    },
    onPaymentSelectionChange () {
      // When payment selection is enabled, disable all other payment methods
      if (this.enabledPaymentMethods.paymentSelection) {
        this.enabledPaymentMethods.cash = false
        this.enabledPaymentMethods.card = false
        this.enabledPaymentMethods.r1 = false
      }
      this.savePaymentMethodsConfig()
    },
    async savePaymentMethodsConfig () {
      try {
        const cashReg = state.getCashRegister()
        await df.doc(`cash_registers/${cashReg.id}`).update({
          enabled_payment_methods: this.enabledPaymentMethods
        })
        state.setEnabledPaymentMethods(this.enabledPaymentMethods)

        // Trigger refresh in payment panel
        this.$root.$emit('payment-methods-updated')
      } catch (err) {
        console.error('Error saving payment methods config:', err)
      }
    },
    loadFloorPlanSetting () {
      try {
        const key = this.getFloorPlanStorageKey()
        const saved = localStorage.getItem(key)
        if (saved !== null) {
          this.useFloorPlan = saved === 'true'
        }
      } catch (err) {
        console.error('Error loading floor plan setting:', err)
      }
    },
    saveFloorPlanSetting () {
      try {
        const key = this.getFloorPlanStorageKey()
        localStorage.setItem(key, this.useFloorPlan.toString())

        // Emit event to update PanelPaymentSelection
        EventBus.$emit('floor-plan-mode-changed', this.useFloorPlan)
      } catch (err) {
        console.error('Error saving floor plan setting:', err)
      }
    },
    loadTableSettings () {
      try {
        // Check if this is a migration from old settings
        const oldFloorPlanKey = this.getFloorPlanStorageKey()
        const oldFloorPlanValue = localStorage.getItem(oldFloorPlanKey)

        if (oldFloorPlanValue !== null && !localStorage.getItem(this.getTableSettingsInitializedKey())) {
          // Migration from old useFloorPlan setting
          console.log('Migrating from old floor plan setting')
          this.useTables = true
          this.tableMode = oldFloorPlanValue === 'true' ? 'floor' : 'list'
          // Remove old key
          localStorage.removeItem(oldFloorPlanKey)
          this.saveTableSettings()
          localStorage.setItem(this.getTableSettingsInitializedKey(), 'true')
        } else {
          // Load new settings
          const useTablesKey = this.getTableSettingsStorageKey()
          const tableModeKey = this.getTableModeStorageKey()

          const savedUseTables = localStorage.getItem(useTablesKey)
          const savedTableMode = localStorage.getItem(tableModeKey)

          if (savedUseTables !== null) {
            this.useTables = savedUseTables === 'true'
          }
          if (savedTableMode !== null) {
            this.tableMode = savedTableMode
          }
        }
      } catch (err) {
        console.error('Error loading table settings:', err)
      }
    },
    saveTableSettings () {
      try {
        const useTablesKey = this.getTableSettingsStorageKey()
        const tableModeKey = this.getTableModeStorageKey()

        localStorage.setItem(useTablesKey, this.useTables.toString())
        localStorage.setItem(tableModeKey, this.tableMode)

        // Emit event to update PanelPaymentSelection
        EventBus.$emit('table-settings-changed', {
          useTables: this.useTables,
          tableMode: this.tableMode
        })
      } catch (err) {
        console.error('Error saving table settings:', err)
      }
    },
    loadModalCloseSetting () {
      try {
        const key = this.getModalCloseStorageKey()
        const saved = localStorage.getItem(key)
        if (saved !== null) {
          this.closeModalOnProductClick = saved === 'true'
        }
      } catch (err) {
        console.error('Error loading modal close setting:', err)
      }
    },
    saveModalCloseSetting () {
      try {
        const key = this.getModalCloseStorageKey()
        localStorage.setItem(key, this.closeModalOnProductClick.toString())

        // Emit event to update PanelRowsWide
        EventBus.$emit('modal-close-setting-changed', this.closeModalOnProductClick)
      } catch (err) {
        console.error('Error saving modal close setting:', err)
      }
    },
    loadCategoryDisplayMode () {
      try {
        const key = this.getCategoryDisplayModeStorageKey()
        const saved = localStorage.getItem(key)
        this.categoryDisplayMode = saved || 'tiles'
      } catch (err) {
        console.error('Error loading category display mode:', err)
        this.categoryDisplayMode = 'tiles'
      }
    },
    saveCategoryDisplayMode () {
      try {
        const key = this.getCategoryDisplayModeStorageKey()
        localStorage.setItem(key, this.categoryDisplayMode)

        // Emit event to update PanelRowsWide
        EventBus.$emit('category-display-mode-changed', this.categoryDisplayMode)
      } catch (err) {
        console.error('Error saving category display mode:', err)
      }
    },
    loadKeyboardSettings () {
      try {
        const key = this.getLocalStorageKey()
        const saved = localStorage.getItem(key)
        if (saved) {
          const settings = JSON.parse(saved)
          this.keyboardShortcutsEnabled = settings.enabled !== undefined ? settings.enabled : false
          this.showShortcutBadges = settings.showBadges !== undefined ? settings.showBadges : false
        }
      } catch (err) {
        console.error('Error loading keyboard settings:', err)
      }
    },
    saveKeyboardSettings () {
      try {
        const key = this.getLocalStorageKey()
        const settings = {
          enabled: this.keyboardShortcutsEnabled,
          showBadges: this.showShortcutBadges
        }
        localStorage.setItem(key, JSON.stringify(settings))

        // Emit event to update PanelRowsWide
        EventBus.$emit('keyboard-shortcuts-changed', settings)
      } catch (err) {
        console.error('Error saving keyboard settings:', err)
      }
    },
    showExplanation () {
      switch (this.selectedSearchType) {
        case 'query':
          return ''
        case 'load':
          return 'Svi artikli sa cjenika učitat će se u blagajnu radi brže pretrage. <br>Ako se blagajna uspori zbog velike količine artikala, promijenite ovu postavku.'
      }
    },
    onSelectSearchType () {
      var cashReg = state.getCashRegister()
      cashReg.search_type = this.selectedSearchType

      this.saveRegisterSearchType()
      state.setCashRegister(cashReg)
    },
    async saveRegisterSearchType () {
      const me = this
      df.doc(`cash_registers/${state.getCashRegister().id}`).update({ search_type: this.selectedSearchType })
        .then(() => {
        })
        .catch(() => {
          me.hideLoader()
          me.showMsgBox({ text: 'Pogreška prilikom promjene tipa pretraživanja blagajne', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        })
    },
    async loadConfiguration () {
      const conf = await df.doc(`cash_registers/${state.getCashRegister().id}/cart_configuration/configuration`).get()

      if (conf && conf.data()) {
        this.cartConfiguration = conf.data()
        // Ensure action_icons exists (for backwards compatibility)
        if (this.cartConfiguration.action_icons === undefined) {
          this.cartConfiguration.action_icons = false
        }
      } else {
        this.cartConfiguration = {
          rb: true,
          name: true,
          quantity: true,
          pending_quantity: false,
          unit: true,
          single_price: true,
          single_price_discount: true,
          total: true,
          action_icons: false
        }
      }
    },
    close () {
      this.$emit('closeTemplatesDialog')
    },
    async onSelectTemplate () {
      state.setRegisterType(this.selectedTemplate)
      await this.saveRegisterTemplate()
      EventBus.$emit('change-register-template', this.selectedTemplate)
      this.$emit('selectTempate')
      // if (state.getRegisterType() !== 'ai-caffe-wide' && state.getRegisterType() !== 'bottom-up') {
      //   this.$emit('closeTemplatesDialog')
      // }
    },
    async saveRegisterTemplate () {
      try {
        const registerId = state.getCashRegister().id
        const templateValue = this.selectedTemplate
        await df.doc(`cash_registers/${registerId}`).set({
          register_template: templateValue
        }, { merge: true })
      } catch (err) {
        console.error('Error saving template:', err)
      }
    },
    async selectTemplate (template) {
      state.setRegisterType(template)
      this.selectedTemplate = template
      await this.saveRegisterTemplate()
      EventBus.$emit('change-register-template', template)
      this.$emit('selectTempate')
      // if (state.getRegisterType() !== 'ai-caffe-wide' && state.getRegisterType() !== 'bottom-up') {
      //   this.$emit('closeTemplatesDialog')
      // }
    },
    selectPaymentPanel () {
      state.setRegisterPaymentPanel(this.selectedPaymentPanel)
      this.saveRegisterPaymentPanel()
      EventBus.$emit('change-register-payment-panel', this.selectedPaymentPanel)
    },
    async saveRegisterPaymentPanel () {
      try {
        await df.doc(`cash_registers/${state.getCashRegister().id}`).update({
          register_payment_panel: this.selectedPaymentPanel
        })
      } catch (err) {
        console.error('Error saving payment panel:', err)
      }
    },
    adjustTemplate () {
      this.saveTemplate()
      // console.log(this.panelRows, this.panelCols, this.panelColspan)
      state.setPanelRows(this.panelRows)
      state.setPanelCols(this.panelCols)
      state.setPanelColspan(this.panelColspan)
      EventBus.$emit('adjust-template')
    },
    changeCartConfiguration () {
      df.doc(`cash_registers/${state.getCashRegister().id}/cart_configuration/configuration`).set(this.cartConfiguration)
        .then(() => {
          console.info('Cash register update succesfull')
          EventBus.$emit('adjust-cart', this.cartConfiguration)
        })
        .catch((err) => {
          console.error('Error updating cash register: ', err)
        })
      // .finally(() => {
      // })
    },
    saveTemplate () {
      this.panelColspan = 12 / this.panelCols
      df.doc(`cash_registers/${state.getCashRegister().id}`).update({ panel_rows: this.panelRows, panel_cols: this.panelCols, panel_colspan: this.panelColspan })
        .then(() => {
          console.info('Cash register update succesfull')
        })
        .catch((err) => {
          console.error('Error updating cash register: ', err)
        })
      // .finally(() => {
      // })
    },
    async getPanelParams () {
      const register = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()
      this.panelRows = register.data().panel_rows ? register.data().panel_rows : 6
      this.panelCols = register.data().panel_cols ? register.data().panel_cols : 6
      this.panelColspan = register.data().panel_colspan ? register.data().panel_colspan : 12 / this.panelCols
      state.setPanelRows(this.panelRows)
      state.setPanelCols(this.panelCols)
      state.setPanelColspan(this.panelColspan)
    }
  },
  created () {
    if (state.getRegisterType() === 'cash') {
      this.selectedTemplate = 'cash'
    } else if (state.getRegisterType() === 'panel') {
      this.selectedTemplate = 'panel'
    } else if (state.getRegisterType() === 'ai-caffe-wide') {
      this.selectedTemplate = 'ai-caffe-wide'
    } else if (state.getRegisterType() === 'bottom-up') {
      this.selectedTemplate = 'bottom-up'
    } else if (state.getRegisterType() === 'ai-crud') {
      this.selectedTemplate = 'ai-crud'
    } else if (state.getRegisterType() === 'ai-compact') {
      this.selectedTemplate = 'ai-compact'
    } else if (state.getRegisterType() === 'ai-shop') {
      this.selectedTemplate = 'ai-shop'
    }

    if (state.getRegisterPaymentPanel() === 'default' || state.getRegisterPaymentPanel() === '') {
      this.selectedPaymentPanel = 'default'
    } else if (state.getRegisterPaymentPanel() === 'simple') {
      this.selectedPaymentPanel = 'simple'
    }

    this.panelRows = state.getPanelRows()
    this.panelCols = state.getPanelCols()
    this.panelColspan = state.getPanelColspan()
  },

  async mounted () {
    await this.getPanelParams()
    await this.loadConfiguration()
    this.loadKeyboardSettings()
    this.loadModalCloseSetting()
    this.loadCategoryDisplayMode()
    this.loadBarcodeSetting()
    this.loadQuantityBarSetting()
    this.loadPaymentMethodsConfig()
    this.loadFloorPlanSetting() // Keep for backward compatibility

    // Load new table settings (with migration support)
    this.loadTableSettings()

    var cashReg = state.getCashRegister()
    this.selectedSearchType = cashReg.search_type ?? 'query'
  }
}
</script>

<style scoped>
.v-dialog__content >>> .my-custom-dialog {
  position: absolute;
  top: 50px;
}

.panel-container {
  margin-top: 1rem;
}

.tableCart {
  border: 1px solid rgba(57, 137, 201, 0.2);
  table-layout: fixed;
  width: 100% !important;
  border-spacing: 0px;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
}

.tableCart td {
  border: 1px solid rgba(57, 137, 201, 0.15);
  width: 100%/7;
  text-align: center;
  padding: 8px;
  font-size: 13px;
  color: rgba(70, 70, 80, 0.9);
}

.tableCart tr:first-child td {
  padding: 12px 8px;
}

.tableCart tr:last-child td {
  font-weight: 600;
  color: #3989C9;
  background: rgba(57, 137, 201, 0.05);
}

.tableCart .v-input--checkbox {
  justify-content: center;
}

/* Template Settings Modal Styling */
.template-settings-modal {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden;
}

.template-settings-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  padding: 24px 24px 20px !important;
  position: relative;
}

.settings-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: white !important;
  letter-spacing: 0.5px !important;
  margin: 0 !important;
}

.close-settings-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 50% !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.close-settings-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: rotate(90deg) scale(1.1);
}

.template-settings-body {
  padding: 24px 32px !important;
  max-height: 70vh;
  overflow-y: auto;
}

/* Section Titles */
.section-title {
  font-size: 18px !important;
  text-align: center;
  padding-bottom: 15px;
  font-weight: 600 !important;
  color: #3989C9 !important;
  letter-spacing: 0.3px !important;
  margin: 0;
}

.subsection-label {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
  margin-bottom: 8px !important;
}

.section-title-with-help {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
}

.help-icon-btn {
  margin-left: 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.help-icon-btn .v-icon {
  color: #3989C9 !important;
}

.help-icon-btn:hover {
  transform: scale(1.1);
}

/* Dividers */
.template-settings-body .v-divider {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-width: 1px !important;
  margin: 16px 0 !important;
}

/* Rows with settings sections */
.template-settings-body .v-row {
  margin-bottom: 8px;
}

.template-settings-body .v-col p {
  margin-bottom: 8px;
}

/* Switches */
.template-settings-body .v-input--switch {
  margin-top: 8px;
}

.template-settings-body .v-input--switch .v-label {
  color: rgba(70, 70, 80, 0.9) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.template-settings-body .v-input--switch .v-input--selection-controls__input {
  margin-right: 12px;
}

.template-settings-body .v-input--switch .v-input--selection-controls__ripple {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Switch track (background) */
.template-settings-body .v-input--switch .v-input--selection-controls__track {
  background: rgba(120, 120, 130, 0.3) !important;
  border: 1px solid rgba(120, 120, 130, 0.2) !important;
  opacity: 1 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Switch thumb (circle) */
.template-settings-body .v-input--switch .v-input--selection-controls__thumb {
  background: white !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Switch when active (on) */
.template-settings-body .v-input--switch.v-input--is-label-active .v-input--selection-controls__track {
  background: linear-gradient(90deg,
    rgba(76, 175, 80, 0.8) 0%,
    rgba(76, 175, 80, 0.9) 100%) !important;
  border-color: rgba(76, 175, 80, 0.6) !important;
}

.template-settings-body .v-input--switch.v-input--is-label-active .v-input--selection-controls__thumb {
  background: white !important;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.4) !important;
}

.template-settings-body .v-input--switch:hover .v-input--selection-controls__thumb {
  transform: scale(1.1);
}

/* Caption text (info/help text) */
.template-settings-body .text-caption {
  color: rgba(70, 70, 80, 0.7) !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
}

/* Select fields */
.template-settings-body .v-select {
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 8px !important;
}

.template-settings-body .v-select .v-input__control {
  border-radius: 8px !important;
}

.template-settings-body .v-select .v-input__slot {
  background: rgba(255, 255, 255, 0.6) !important;
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(57, 137, 201, 0.08) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.template-settings-body .v-select:hover .v-input__slot {
  border-color: rgba(57, 137, 201, 0.4) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
}

.template-settings-body .v-select.v-input--is-focused .v-input__slot {
  border-color: rgba(0, 179, 190, 0.6) !important;
  box-shadow: 0 2px 12px rgba(0, 179, 190, 0.2) !important;
}

.template-settings-body .v-select .v-select__selection {
  color: rgba(70, 70, 80, 0.9) !important;
  font-weight: 500 !important;
}

.template-settings-body .v-select .v-icon {
  color: #3989C9 !important;
}

.template-settings-body .v-text-field {
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 8px !important;
}

/* Checkboxes */
.template-settings-body .v-input--checkbox {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.template-settings-body .v-input--checkbox .v-icon {
  color: #4CAF50 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.template-settings-body .v-input--checkbox:hover .v-icon {
  transform: scale(1.1);
}

.template-settings-body .v-input--checkbox .v-input--selection-controls__ripple {
  color: #4CAF50 !important;
}

/* Radio groups */
.template-settings-body .v-radio-group {
  margin-top: 8px;
}

.template-settings-body .v-radio {
  margin-right: 24px;
}

.template-settings-body .v-radio .v-label {
  color: rgba(70, 70, 80, 0.9) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin-left: 4px;
}

.template-settings-body .v-radio .v-icon {
  color: #3989C9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.template-settings-body .v-radio:hover .v-icon {
  transform: scale(1.1);
}

.template-settings-body .v-radio .v-input--selection-controls__ripple {
  color: #3989C9 !important;
}

/* Radio button when checked */
.template-settings-body .v-item--active .v-icon {
  color: #00B3BE !important;
}

.template-settings-body .v-item--active .v-label {
  color: #00B3BE !important;
  font-weight: 600 !important;
}

/* Sliders */
.template-settings-body .v-slider {
  margin-top: 8px;
  padding-top: 8px;
}

.slider-label {
  display: flex;
  align-items: center;
  color: rgba(70, 70, 80, 0.9) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.template-settings-body .v-slider__track-container {
  height: 6px !important;
  border-radius: 3px !important;
}

.template-settings-body .v-slider__track-background {
  background: rgba(57, 137, 201, 0.15) !important;
  border-radius: 3px !important;
}

.template-settings-body .v-slider__track-fill {
  background: linear-gradient(90deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.9) 100%) !important;
  border-radius: 3px !important;
}

.template-settings-body .v-slider__thumb {
  width: 20px !important;
  height: 20px !important;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 100%) !important;
  box-shadow: 0 2px 8px rgba(0, 179, 190, 0.4) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.template-settings-body .v-slider__thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.6) !important;
}

.template-settings-body .v-slider__thumb-label {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(57, 137, 201, 0.95) 100%) !important;
  border-radius: 4px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
}

.template-settings-body .v-slider__thumb-label::before {
  border-top-color: rgba(0, 179, 190, 0.95) !important;
}

/* Scrollbar for settings body */
.template-settings-body::-webkit-scrollbar {
  width: 8px;
}

.template-settings-body::-webkit-scrollbar-track {
  background: rgba(57, 137, 201, 0.05);
  border-radius: 4px;
}

.template-settings-body::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.5) 50%,
    rgba(97, 84, 164, 0.5) 100%);
  border-radius: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.template-settings-body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.8) 0%,
    rgba(57, 137, 201, 0.8) 50%,
    rgba(97, 84, 164, 0.8) 100%);
}

/* Shortcuts Help Dialog Styling */
.shortcuts-help-modal {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden;
}

.shortcuts-help-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  padding: 24px 24px 20px !important;
  position: relative;
}

.modal-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: white !important;
  letter-spacing: 0.5px !important;
  margin: 0 !important;
}

.close-btn-help {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 50% !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.close-btn-help:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: rotate(90deg) scale(1.1);
}

.shortcuts-help-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 24px 32px !important;
}

/* Section Headings with Gradient */
.section-heading {
  display: inline-block !important;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  font-weight: 700 !important;
  font-size: 20px !important;
  letter-spacing: 0.5px !important;
  margin-top: 16px;
}

/* Content Styling */
.shortcuts-help-content ul {
  padding-left: 24px;
  color: rgba(70, 70, 80, 0.9);
}

.shortcuts-help-content li {
  margin-bottom: 12px;
  line-height: 1.7;
  font-size: 14px;
  color: rgba(70, 70, 80, 0.9);
}

.shortcuts-help-content strong {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  font-weight: 600 !important;
}

/* Table Styling */
.shortcuts-table {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  overflow: hidden;
}

.shortcuts-table >>> .v-data-table__wrapper {
  border-radius: 12px !important;
}

.table-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.15) 0%,
    rgba(57, 137, 201, 0.1) 50%,
    rgba(97, 84, 164, 0.15) 100%) !important;
  color: #3989C9 !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 16px !important;
}

.shortcuts-table >>> tbody tr {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.shortcuts-table >>> tbody tr:hover {
  background: rgba(57, 137, 201, 0.08) !important;
}

.shortcuts-table >>> tbody td {
  padding: 12px 16px !important;
  font-size: 14px !important;
  color: rgba(70, 70, 80, 0.9) !important;
}

/* Actions Footer */
.shortcuts-help-actions {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  padding: 16px 24px !important;
  border-top: 1px solid rgba(57, 137, 201, 0.1) !important;
}

.close-action-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 32px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.close-action-btn:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

/* Scrollbar Styling */
.shortcuts-help-body::-webkit-scrollbar {
  width: 8px;
}

.shortcuts-help-body::-webkit-scrollbar-track {
  background: rgba(57, 137, 201, 0.05);
  border-radius: 4px;
}

.shortcuts-help-body::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.5) 50%,
    rgba(97, 84, 164, 0.5) 100%);
  border-radius: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.shortcuts-help-body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.8) 0%,
    rgba(57, 137, 201, 0.8) 50%,
    rgba(97, 84, 164, 0.8) 100%);
}
</style>
